import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useErrorStore } from '@/pinia/helpers';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  setup(__props) {

const errorStore = useErrorStore();

const error = computed(() => {
  return errorStore.error.message ? errorStore.error : store.getters.error;
});

function hide() {
  errorStore.clearError();
  store.commit('clearStore');
}

return { __sfc: true,errorStore, error, hide }
}

})